import { Button, Colors, MuiModal, Text } from '@pinchenterprisesnpm/friday-ui'
import { InfoParagraph } from '@src/features/shift-post-v2/steps/shift-details-step/components/location-section/location-section.styles'
import { ILocationSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/location-section/location-section.types'
import { connect, FormikProps } from 'formik'

const { Header, Content, Footer } = MuiModal

interface ISeeArrivalInstructionsModalProps {
  isOpen: boolean
  closeModal: () => void
  formik: FormikProps<ILocationSectionFormValues>
}

export const SeeArrivalInstructionsModal = connect<
  ISeeArrivalInstructionsModalProps
>(({ isOpen, closeModal, formik }) => {
  const {
    values: { location },
  } = formik

  return (
    <MuiModal isOpen={isOpen} closeModal={closeModal} fullWidth maxWidth="md">
      <Header title="Location" />

      <Content>
        <Text fontSize="medium" mt="xs" color={Colors.dark}>
          {location?.name ?? '/'}
        </Text>

        <Text fontSize="medium">Arrival Instructions</Text>

        <InfoParagraph
          dangerouslySetInnerHTML={{
            __html: location?.property_arrival_instructions ?? '',
          }}
        />
      </Content>

      <Footer>
        <Button onClick={closeModal}>Okay</Button>
      </Footer>
    </MuiModal>
  )
})
